import React from 'react';
import './LogoIcon.css';

function LogoIcon() {
  return <div className="logo-icon" />;
}

export default LogoIcon;
